import { ClassProvider, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { Observable, concat } from 'rxjs';
import { filter, first, map, mergeMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';

import { RefreshTokenService } from '@fitscovery/utils/refresh-token-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	constructor (
    private store: Store,
    private refreshToken: RefreshTokenService
  ) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.store.selectSnapshot(e => e.auth.token);
    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(token);

    if (!token) return next.handle(request);

    return isExpired
      ? this.refreshAndSetNewTokenToState(request, next, token) 
      : this.reuseToken(request, next, token);
	}

  private reuseToken(request: HttpRequest<any>, next: HttpHandler, token: string): Observable<HttpEvent<any>> {
    const headers = request.clone({ setHeaders: { Authorization: token } });
    return next.handle(headers)
  }

  private refreshAndSetNewTokenToState(request: HttpRequest<any>, next: HttpHandler, token: string): Observable<HttpEvent<any>> {

    const authState$ = this.refreshToken.getAndSetNewTokenToState().pipe(
      first(),
      map((token: string | boolean) => (!!token ? request.clone({ setHeaders: { Authorization: token as string } }) : request)),
      mergeMap((request: HttpRequest<any>) => next.handle(request))
    );

    return concat(this.reuseToken(request, next, token), authState$).pipe(
      filter((e: any) => e.type !== 0),
    );
  }

}

export const TokenInterceptorProvider: ClassProvider = {
	provide: HTTP_INTERCEPTORS,
	useClass: TokenInterceptor,
	multi: true
};
